module.exports = __webpack_public_path__ + "static/media/UNDR Sounds.89cc6db2.png";